export enum PushNotificationEventType {
  Install,
  Registration,
  Deposit,
}
